"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "11px",
    height: "12px",
    viewBox: "31 14 11 12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33,19 L33,24 L40,24 L40,19 L33,19 Z M31,17.5 C31,16.6715729 31.6715406,16 32.5064385,16 L33,16 L33,14.9998075 C33,14.4476291 33.4438648,14 34,14 C34.5522847,14 35,14.4437166 35,14.9998075 L35,16 L38,16 L38,14.9998075 C38,14.4476291 38.4438648,14 39,14 C39.5522847,14 40,14.4437166 40,14.9998075 L40,16 L40.4935615,16 C41.3255445,16 42,16.6657972 42,17.5 L42,24.9999999 C42,25.5522847 41.555163,26 41.0044225,26 L31.9955775,26 C31.4457352,26 31,25.5561352 31,25 L31,17.5 Z M38,20 L39,20 L39,21 L38,21 L38,20 Z M36,20 L37,20 L37,21 L36,21 L36,20 Z M38,22 L39,22 L39,23 L38,23 L38,22 Z M36,22 L37,22 L37,23 L36,23 L36,22 Z M34,22 L35,22 L35,23 L34,23 L34,22 Z M34,20 L35,20 L35,21 L34,21 L34,20 Z",
    id: "Combined-Shape",
    stroke: "none",
    fillRule: "evenodd"
  }));
};

exports["default"] = _default;